<template>
	<b-container fluid>
		<b-navbar
			v-if="$route.matched.some(route => route.name != 'Login')"
			toggleable="md"
		>
			<b-navbar-brand>
				<b-img
					:src="require('@/assets/logo.png')"
					width="320"
					rounded
					alt="LifeForce PT"
				></b-img>
			</b-navbar-brand>

			<b-navbar-toggle class="hamburger" target="nav-collapse"></b-navbar-toggle>

			<b-collapse id="nav-collapse" is-nav>
				<b-navbar-nav>
					<b-nav-item 
						to="/" 
						exact-active-class="activeNavLink"
						class="text-center"
					>
						Dashboard
					</b-nav-item>
					<b-nav-item 
						to="/MedEx" 
						exact-active-class="activeNavLink"
						class="text-center"
					>
						MedEx</b-nav-item
					>
					<b-nav-item 
						to="/MedExOnline" 
						exact-active-class="activeNavLink"
						class="text-center"
					>
						MedEx Online</b-nav-item
					>

					<b-nav-item 
						to="/Account" 
						exact-active-class="activeNavLink"
						class="text-center"
					>
						Account</b-nav-item
					>

					<b-nav-item 
						v-if="isAdmin"
						to="/Settings" 
						exact-active-class="activeNavLink"
						class="text-center"
					>
						Settings</b-nav-item
					>
				</b-navbar-nav>

				<!-- Right aligned nav items -->
				<b-navbar-nav class="ml-auto">
					<b-button
						@click="logOut()"
						variant="danger"
						class="py-2 d-inline-block"
						pill
					>
						<b-icon icon="power"></b-icon> Logout
					</b-button>
				</b-navbar-nav>
			</b-collapse>
		</b-navbar>

		<router-view />
	</b-container>
</template>

<script>
export default {
	name: "App",
	methods: {
		logOut: function() {
			this.$store.dispatch("logout").then(() => {
				this.$router.push("/Login")
			})
		},
	},
	computed: {
		isAdmin() {
			return this.$store.getters.isAdmin
		},
	},
}
</script>

<style>
#app {
	font-family: Avenir, Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	color: #2c3e50;
}
</style>

<style scoped>
.hamburger {
	color: black;
	fill: black;
	border: 1px solid black;
}

.activeNavLink {
	color: rgb(28, 127, 181) !important;
	border-bottom: 3px solid rgb(90, 160, 69);
	outline: none;
}

</style>
